import { CapturedImage } from "./CapturedImage";
import { Process } from "../../Process";
import { ScreenRectangle } from "../ScreenRectangle";
import { AbstractCaptureService, CaptureInterval, CaptureService } from "./CaptureService";
export class Alt1ScreenCaptureService extends AbstractCaptureService {
    constructor() {
        super();
        const self = this;
        this.ticker = new class extends Process.Interval {
            constructor() {
                super(...arguments);
                this.start_time = undefined;
            }
            async tick() {
                if (!window.alt1?.rsLinked)
                    return;
                const now = Date.now();
                this.start_time ?? (this.start_time = now);
                const time = {
                    tick: ~~((now - this.start_time) / CaptureService.MIN_CAPTURE_INTERVAL),
                    time: now
                };
                self.doIfAnyInterest(time, interested_in_this_tick => {
                    const required_area = ScreenRectangle.union(...interested_in_this_tick.map(t => t?.area ?? { origin: { x: 0, y: 0 }, size: { x: alt1.rsWidth, y: alt1.rsHeight } }));
                    const capture = CapturedImage.capture(required_area);
                    if (!capture)
                        return undefined;
                    return capture;
                });
            }
        }(1000 / CaptureInterval.globalCapturingFps() / 2);
        this.ticker.run();
    }
    transformValueForNotification(options, raw_value) {
        return options?.area ? raw_value.value.getScreenSection(options.area) : raw_value.value;
    }
}
